import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../input';
import { useGlobal } from '../../state';

export const Inner = ({ examples, initialParams, endpoint, disabled, renderChildren, onRun }) => {
  const navigate = useNavigate();
  const { fox } = useGlobal();
  const [params, setParams] = useState(initialParams || {});
  const [loading, setLoading] = useState();

  const handleChange = (field, value) => {
    const copy = JSON.parse(JSON.stringify(params));
    copy[field] = value;

    for (const key of Object.keys(copy)) {
      const val = copy[key];
      console.log('??', key, val);
      if (val === null || val === undefined || val == '') {
        delete copy[key];
      }
    }

    setParams(copy);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log('Run', endpoint, params);
    const job = await fox[endpoint].detach(params);
    console.log('Detached job', job);
    navigate('/jobs/' + job.id);
    if (onRun) {
      onRun(job);
    }
  };

  const examplesNode = (
    <div style={{ fontSize: 12, marginBottom: 10, display: 'flex', alignItems: 'center', gap: 5 }}>
      <div>Fill example:</div>
      <div>
        {(examples || []).map((it) => (
          <Button small trans onClick={() => setParams(it.params)}>
            {it.name}
          </Button>
        ))}
      </div>
    </div>
  );

  return (
    <div>
      {!initialParams && !!examples?.length && examplesNode}

      <form style={{ display: 'flex', flexDirection: 'column', gap: 10 }} onSubmit={handleSubmit}>
        {renderChildren(params, handleChange, setParams)}
        <Button disabled={disabled} loading={loading} style={{ width: 180, marginTop: 10 }} type="submit">
          Run
        </Button>
        {/*
        INNER:<pre>{JSON.stringify(params, null, 2)}</pre>
        INNER INITIAL:<pre>{JSON.stringify(initialParams, null, 2)}</pre>
        */}
      </form>
    </div>
  );
};
